<div class="Modal ModalCircular">
  <div class="HeaderModal">
    <div class="IconModal float-start">
      <p>circular</p>
    </div>
    <span class="material-icons float-end CloseModal" (click)="closeModal()">
      close
    </span>
  </div>
  <div class="ModalContent">

    <!--<pdf-viewer [src]="policity.pdf"  style="width:  100%; height: 500px" [original-size]="false" [show-all]="true" [autoresize]="true" [fit-to-page]="true"  ></pdf-viewer>-->
    <a href="#">
      <span class="material-icons me-3"> file_download </span>
      Baixar a circular
    </a>
  </div>
</div>
